import React from 'react'

import { Container } from 'react-bootstrap'

import Footer from './style'

const CustomFooter = () => {
    return (
        <Footer>
            <Container>
                <p>Cartão Express Partners ® Todos os direitos reservados Fast Midia 2026.</p>
            </Container>
        </Footer>
    )
}

export default CustomFooter